import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {    
    getPerfisUsuario(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("perfisUsuario/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPerfilUsuario(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("perfisUsuario/access/obter", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPerfilUsuarioTarefas(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("perfisUsuario/access/obterTarefas", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postPerfilUsuario(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("perfisUsuario/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deletePerfilUsuario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("perfisUsuario/access/excluir", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};